<template>
  <div :class="{ '--centered': centered }">
    <p class="section__header">{{ content.hat }}</p>
    <h1 class="title">{{ content.title }}</h1>
    <Image v-if="content.image" :source="content.image" class="--title-block" />
    <p>{{ content.description }}</p>
  </div>
</template>

<script>
import { Image } from '@/components/global'
import { ContentPropMixin } from '@/mixins'

export default {
  name: 'TitleBlock',
  mixins: [ContentPropMixin],
  components: { Image },
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
